import { createLinkDeduper } from './createLinkDeduper.ts';
import type { EnhancedSmartLink } from './smartLinkTypes.ts';

// Appends the links not already present — by `createLinkDeduper`, the same identity
// `hydrateIncomingLinks` dedupes on — re-indexed so `occurrenceIndex` stays the global position and
// recency order is preserved across pages.
export const appendNewLinks = (
	prev: EnhancedSmartLink[],
	incoming: EnhancedSmartLink[],
): EnhancedSmartLink[] => {
	const isDuplicate = createLinkDeduper(prev);
	const fresh: EnhancedSmartLink[] = [];
	incoming.forEach((link) => {
		if (isDuplicate(link)) {
			return;
		}
		fresh.push({ ...link, occurrenceIndex: prev.length + fresh.length });
	});
	return fresh.length > 0 ? [...prev, ...fresh] : prev;
};
